module.exports = __webpack_public_path__ + "img/901543124.d994348b.png";